import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const ClientsSection = () => {
  const { t } = useLanguage();

  const clientLogos = [
    {
      id: 1,
      name: 'Kids Tooth',
      logo: 'https://customer-assets.emergentagent.com/job_netgains-redesign/artifacts/xp50qz6x_Kids-Tooth-logo%20%281%29.png'
    },
    {
      id: 2,
      name: 'Sinnara Basmati',
      logo: 'https://customer-assets.emergentagent.com/job_netgains-redesign/artifacts/181hg9lo_images.jpg'
    },
    {
      id: 3,
      name: 'Euroclima',
      logo: 'https://customer-assets.emergentagent.com/job_netgains-redesign/artifacts/7z8rosg3_Euroclima-logo-2018.jpg'
    },
    {
      id: 4,
      name: 'MH Food',
      logo: 'https://customer-assets.emergentagent.com/job_netgains-redesign/artifacts/fgwmwoix_64787f9ab938260cf096f45e_MH-Food-Logo.png'
    },
    {
      id: 5,
      name: 'Specta',
      logo: 'https://customer-assets.emergentagent.com/job_netgains-redesign/artifacts/6x1u9kb0_Specta.jpg'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t({ en: 'Trusted by Leading Businesses', ar: 'موثوق به من قبل الشركات الرائدة' })}
          </h2>
          <p className="text-lg text-gray-600">
            {t({
              en: 'Many of our clients return to us not just for properties — but for perspective, partnerships, and performance.',
              ar: 'يعود العديد من عملائنا إلينا ليس فقط للعقارات — ولكن للرؤية والشراكات والأداء.'
            })}
          </p>
        </div>

        {/* Client Logos */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll-slow">
            {[...clientLogos, ...clientLogos].map((client, index) => (
              <div
                key={`${client.id}-${index}`}
                className="flex-shrink-0 w-48 h-28 mx-6 flex items-center justify-center bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-4"
              >
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
